import { accountBadgeEntityName } from '../../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../../ui/hooks';
import { PageError } from '@juvare/common-web-ui/PageError';
import { getErrorMessage, signalPdfError, signalPdfReady } from '@juvare/common-web-ui/utils';
import { useAttachmentDataUrl } from '@juvare/platform-sdk-react/ui/hooks';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';
export const BadgePrintPreview = ({ imageAttachmentKey }) => {
    const { t } = useBadgingTranslation();
    const { accountBadgeId } = useParams();
    const { data: imageDataUrl, isLoading, error } = useAttachmentDataUrl(accountBadgeEntityName, accountBadgeId, imageAttachmentKey);
    // const [fixedImageDataUrl, setFixedImageDataUrl] = React.useState<string | undefined>(imageDataUrl);
    // const updateRotationAndPosition = (decodedBase64String: string, rotation: number) => {
    //     const svgTag = '<svg';
    //
    //     const splitString = decodedBase64String.split(svgTag);
    //
    //     const rotateString = `transform="rotate(${rotation} -114, 0)"`;
    //
    //     const rotatedString = splitString[0] + svgTag + ' ' + rotateString + splitString[1];
    //
    //     return rotatedString;
    // };
    // const getAttributeValue = (decodedBase64String: string, attribute: string) => {
    //     const svgTag = '<svg';
    //
    //     const splitString = decodedBase64String.split(svgTag);
    //
    //     const attributeStart = `${attribute}="`;
    //     const splitAttribute = splitString[1].split(attributeStart);
    //
    //     const attributeStartIndex = splitAttribute[0].length;
    //     const attributeEndIndex = splitAttribute[1].indexOf('" ') + attributeStartIndex + attributeStart.length + 1; // +1 so we include " which we counted as the end index to.
    //
    //     // Will be {attribute}="{value}"
    //     const attributeString = splitString[1].slice(attributeStartIndex, attributeEndIndex);
    //
    //     // Will be {value}
    //     const attributeValuesString = attributeString.split('"')[1];
    //
    //     return { attributeString, attributeValuesString };
    // };
    // const updateAttributeValues = (
    //     decodedBase64String: string,
    //     attribute: string,
    //     newValueCallback: (attributeCurrentValuesString: string) => string,
    // ) => {
    //     const { attributeString, attributeValuesString } = getAttributeValue(decodedBase64String, attribute);
    //
    //     const newAttributeValueString = newValueCallback(attributeValuesString);
    //
    //     const splitAttributeString = decodedBase64String.split(attributeString);
    //
    //     const updatedViewBoxString = splitAttributeString[0] + `${attribute}="${newAttributeValueString}"` + splitAttributeString[1];
    //
    //     return updatedViewBoxString;
    // };
    // const switchHeightAndWidthValues = (decodedBase64String: string) => {
    //     const currentHeight = getAttributeValue(decodedBase64String, 'height').attributeValuesString;
    //     const currentWidth = getAttributeValue(decodedBase64String, 'width').attributeValuesString;
    //
    //     const base64WithUpdatedHeight = updateAttributeValues(decodedBase64String, 'height', () => {
    //         return currentWidth;
    //     });
    //
    //     const base64WithUpdatedWidth = updateAttributeValues(base64WithUpdatedHeight, 'width', () => {
    //         return currentHeight;
    //     });
    //
    //     return base64WithUpdatedWidth;
    // };
    // const rotateImageIfNeeded = (imageDataUrl: string) => {
    //     const base64Tag = 'base64,';
    //
    //     const base64 = imageDataUrl.split(base64Tag);
    //
    //     const decodedBase64String = atob(base64[1]);
    //
    //     const splitDecodedBase64String = [decodedBase64String.slice(0, 300), decodedBase64String.slice(300)];
    //
    //     const updatedRotation = updateRotationAndPosition(splitDecodedBase64String[0], 90);
    //
    //     // const updatedViewBox = updateAttributeValues(updatedRotation, 'viewBox', (currentValue: string) => {
    //     //     const [minX, minY, width, height] = currentValue.split(' ');
    //     //     const newViewBoxValue = `${minY} ${minX} ${height} ${width}`;
    //     //
    //     //     return newViewBoxValue;
    //     // });
    //     //
    //     // const updatedHeightAndWidth = switchHeightAndWidthValues(updatedViewBox);
    //
    //     console.log('updatedHeightAndWidth', updatedRotation);
    //
    //     const encodedBase64String = btoa(updatedRotation + splitDecodedBase64String[1]);
    //
    //     const updatedBase64 = base64[0] + base64Tag + encodedBase64String;
    //
    //     return updatedBase64;
    // };
    React.useEffect(() => {
        if (accountBadgeId && imageDataUrl) {
            // const updatedImageUrl = rotateImageIfNeeded(imageDataUrl);
            // setFixedImageDataUrl(updatedImageUrl);
            signalPdfReady();
            // console.log('imageDataUrl', base64)
        }
        else if (error) {
            signalPdfError(getErrorMessage(error));
        }
    }, [accountBadgeId, imageDataUrl, error]);
    if (error) {
        return React.createElement(PageError, { type: 'not-found', error: error });
    }
    if (isLoading) {
        return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' } },
            React.createElement(CircularProgress, null)));
    }
    // size: 2.125in 3.375in;
    return (React.createElement(React.Fragment, null,
        React.createElement("style", null, `
                    @page {
                        size: 2.125in 3.375in;
                    }
                `),
        React.createElement(Box, { component: 'img', sx: { maxWidth: '100%', display: 'block', objectFit: 'fill' }, src: imageDataUrl, alt: t('common.accountBadge') })));
};
